import React from 'react'
import Stories from '../stories/ReactInstaStories'
import questModel from '../quests/questModel'
import answerModel from 'components/answers/answerModel'
import PlayStorySlide from './PlayStorySlide'
import { extractUrls } from 'components/shared/LinkPreview'
import perms from 'lib/perms'
import * as cache from 'state/cache'
import { getAnswerPlayMedia, getAnswerPlayMediaItems, isTrackedPlayMedia } from './playStoryMedia'

export default function PlayAll(props) {
    const quest = props.modalParams.quest
    const isBsv = perms.isPublic(quest)

    const createStory = (answer, media, storyProps = {}) => {
        return {
            id: `${answer?.id || 'answer'}:${media.kind}:${
                media.src ||
                media.mp4Src ||
                media.imageSrc ||
                media.url ||
                media.file?.id ||
                media.file?.url ||
                'story'
            }`,
            answer,
            quest,
            media,
            isBsv,
            content: innerProps => <PlayStorySlide {...innerProps} />,
            ...storyProps,
        }
    }

    const hasTrackedEmbeddedMedia = embeds => {
        for (const embed of embeds || []) {
            const resolvedEmbed = cache.getCachedAnswer(embed?.id) || embed
            const extractedUrls = extractUrls(resolvedEmbed?.delta_json)
            const embedAttachmentState = answerModel.getComposeAttachmentState({
                answer: resolvedEmbed,
                extractedUrls,
                hiddenPreviewUrls: [],
                resolveEmbedAnswer: nestedEmbed =>
                    cache.getCachedAnswer(nestedEmbed?.id) || nestedEmbed,
            })
            if (isTrackedPlayMedia(getAnswerPlayMedia(resolvedEmbed))) return true
        }

        return false
    }

    const getAnswerStory = sourceAnswer => {
        const answer = cache.getCachedAnswer(sourceAnswer?.id) || sourceAnswer
        const attachmentState = answerModel.getComposeAttachmentState({
            answer,
            extractedUrls: extractUrls(answer?.delta_json),
            hiddenPreviewUrls: [],
            resolveEmbedAnswer: embed => cache.getCachedAnswer(embed?.id) || embed,
        })
        const mediaItems = getAnswerPlayMediaItems(answer)

        return mediaItems.map(media =>
            createStory(
                answer,
                media,
                isTrackedPlayMedia(media)
                    ? { trackDuration: true, duration: 6500 }
                    : {
                          duration: 6500,
                          trackDuration:
                              media.kind === 'text' &&
                              hasTrackedEmbeddedMedia(attachmentState.embeds),
                      },
            ),
        )
    }

    let stories = []

    const parentAnswer = props.modalParams.quest?.parent
    if (parentAnswer && !quest.parent?.is_transcription) stories.push(getAnswerStory(parentAnswer))
    const answers = questModel.filterUnarchivedAnswers(questModel.sortedQuestAnswers(quest))
    stories = stories.concat(
        answers.map(answer => {
            return getAnswerStory(answer)
        }),
    )

    const flatStories = stories.flat()

    return (
        <Stories
            stories={flatStories}
            height={props.height}
            width={'100%'}
            onAllStoriesEnd={props.closeModal}
        />
    )
}
